import {
  AUTHENTICATE,
  AUTHENTICATE_ERROR_AUTH,
} from '../actions/authActions';

import { getUser } from '../../hooks/auth/getUser';

const data = getUser();

const initialState = {
  fullName: data.displayName ?? '',
  avatar: data.photoURL ?? '',
  fullData: data
};

export default function (state = initialState, action) {
  switch (action.type) {
    case AUTHENTICATE:
      return { ...state, fullName: action.user.name, avatar: action.user.avatar ?? state.avatar };
    case AUTHENTICATE_ERROR_AUTH:
      return { error: action.error };
    default:
      return state;
  }
}
